// import history from 'src/lib/history';
import RestClient from '../../config/rest-client';
import processError from '../../lib/error';
import {uniq} from 'lodash'

export function getQuestionExportDocx(body) {
  return async (dispatch) => {
    try {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions/export', 'docx', body);
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      return result;
    } catch (error) {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
    }
  };
}
export function getQuestionExportQti(body) {
  return async (dispatch) => {
    try {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions/export', 'qti', body);
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      return result;
    } catch (error) {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
    }
  };
}


export function getQuestionExportPowerPoint(body) {
  return async (dispatch) => {
    try {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions/export', 'powerpoint', body);
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      return result;
    } catch (error) {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
    }
  };
}

export function getQuestionExportPdf(body) {
  return async (dispatch) => {
    try {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions/export', 'pdf', body);
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      return result;
    } catch (error) {
      // dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
    }
  };
}

export function getQuestionLabels() {
  return async (dispatch) => {
    try {
      let result = await RestClient.find('labels');
      dispatch({type: 'SET_QUESTION_LABELS', data: result})
    } catch (error) {
      throw new Error('ss');
    }
  };
}

export function updateLabel(body) {
  return async (dispatch) => {
    try {
      let result = await RestClient.update('labels', body.id, body);
      dispatch({type: 'SET_QUESTION_LABEL_UPDATE', data: result})
    } catch (error) {
      throw new Error('ss');
    }
  };
}
export function deleteLabel(id) {
  return async (dispatch) => {
    try {
      let result = await RestClient.delete('labels', id);
      dispatch({type: 'SET_QUESTION_LABEL_DELETE', data: id})
    } catch (error) {
      throw new Error('ss');
    }
  };
}

export function createLabel(body) {
  return async (dispatch) => {
    try {
      let result = await RestClient.create('labels', body);
      dispatch({type: 'SET_QUESTION_LABEL_CREATE', data: result})
    } catch (error) {
      throw new Error('ss');
    }
  };
}

export function addLabelQuestion(body, question) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions', 'label', body);
      question.labels = [...question.labels, result]
      dispatch({
        type: 'UPDATE_QUESTION',
        data: question,
      });
      // dispatch({type: 'SET_QUESTION_LABEL_CREATE', data: result})
    } catch (error) {
      throw new Error('ss');
    }
  };
}

export function deleteLabelQuestion(id, question) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.delete('questions/label', id);
      question.labels = question.labels.filter(_i => _i.id != id)
      dispatch({
        type: 'UPDATE_QUESTION',
        data: question,
      });
      // dispatch({type: 'SET_QUESTION_LABEL_CREATE', data: result})
    } catch (error) {
      throw new Error('ss');
    }
  };
}

export function addCommentQuestion(body, question) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions', 'comment', body);
      question.comments = [...question.comments, result]
      dispatch({
        type: 'UPDATE_QUESTION',
        data: question,
      });
      // dispatch({type: 'SET_QUESTION_LABEL_CREATE', data: result})
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
    }
  };
}

export function deleteCommentQuestion(id, question) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.delete('questions/comment', id);
      question.comments = question.comments.filter(_i => _i.id != id)
      dispatch({
        type: 'UPDATE_QUESTION',
        data: question,
      });
      // dispatch({type: 'SET_QUESTION_LABEL_CREATE', data: result})
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
    }
  };
}


export function getQuestions(where) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions', 'list', where);
      // if(where.categories || where.subcategories){
      //   result = await RestClient.get('questions', '', where);
      // }
      
      dispatch({
        type: 'SET_QUESTIONS',
        data: result.rows,
        count: result.count,
        statistic: result.statistic,
        statistic_total: result.statistic_total,
        query: where
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function getQuestionsTrashed() {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS',
        data: [],
      });
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.get('questions', 'trashed');
      
      dispatch({
        type: 'SET_QUESTIONS',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function createQuestions(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.create('questions', body);
      // dispatch({
      //   type: 'CREATE_QUESTION',
      //   data: data,
      // });
      return data;
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function updateQuestions(body, isUpdate = true) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.update('questions', body.id, body);
      if(isUpdate){
        dispatch({
          type: 'UPDATE_QUESTION',
          data: data,
        });
      }
      return data;
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function undoQuestions(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.update('questions', body.id, {status: 1});
      dispatch({
        type: 'DELETE_QUESTION',
        data: body.id,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function deleteQuestion(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.delete('questions', id);
      // dispatch({
      //   type: 'DELETE_QUESTION',
      //   data: id,
      // });
      return true
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function destroyQuestion(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.delete('questions/destroy', id);
      dispatch({
        type: 'DELETE_QUESTION',
        data: id,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function statisticDeleteQuestion(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const data = await RestClient.delete('questions/statistic', id);
      dispatch({
        type: 'UPDATE_QUESTION',
        data: data,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      console.log("🚀 ~ file: actions.js:15 ~ return ~ error:", error)
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function getSubjects() {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.get('subjects', '');
      dispatch({
        type: 'SET_QUESTIONS_SUBJECTS',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export function getSources() {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.get('sources', '');
      dispatch({
        type: 'SET_QUESTIONS_SOURCES',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function getCategories(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.get('categories', '');
      dispatch({
        type: 'SET_QUESTIONS_CATEGORIES',
        data: result.categories,
        subcategories: result.subcategories,
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:147 ~ return ~ error:", error)
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function createSubjects(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.post('subjects', body);
      dispatch({
        type: 'SET_QUESTIONS_SUBJECTS_ADD',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}
export function createSource(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.post('sources', body);
      dispatch({
        type: 'SET_QUESTIONS_SOURCES_ADD',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function createCategory(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.post('categories', body);
      dispatch({
        type: 'SET_QUESTIONS_CATEGORY_ADD',
        data: result,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function updateCategory(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.update('categories', body.id, body);
      dispatch({
        type: 'SET_QUESTIONS_CATEGORY_UPDATE',
        data: result,
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:143 ~ return ~ error:", error)
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export function updateSubjects(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.put('subjects', body.id, body);
      dispatch({
        type: 'SET_QUESTIONS_SUBJECTS_UP',
        data: result,
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:162 ~ return ~ error:", error)
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export function updateSource(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.put('sources', body.id, body);
      dispatch({
        type: 'SET_QUESTIONS_SOURCES_UP',
        data: result,
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:162 ~ return ~ error:", error)
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export function deleteCategory(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.delete('categories', id);
      dispatch({
        type: 'SET_QUESTIONS_CATEGORY_DELETE',
        data: id,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export function deleteSubcategory(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.delete('categories/subcategory', id);
      dispatch({
        type: 'SET_QUESTIONS_SUBCATEGORY_DELETE',
        data: id,
      });
    } catch (error) {
      console.log("🚀 ~ file: actions.js:202 ~ return ~ error:", error)
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function deleteSubjects(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.delete('subjects', id);
      dispatch({
        type: 'SET_QUESTIONS_SUBJECTS_DELETE',
        data: id,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function deleteSource(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      const result = await RestClient.delete('sources', id);
      dispatch({
        type: 'SET_QUESTIONS_SOURCES_DELETE',
        data: id,
      });
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}



export function selectSubject(id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: id,
        key: 'selectSubject'
      });
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: null,
        key: 'selectSubcategory'
      });
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: null,
        key: 'selectCategory'
      });
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: [],
        key: 'checkCategories'
      });
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: [],
        key: 'checkSubcategories'
      });
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function selectCategory(id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: id,
        key: 'selectCategory'
      });
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: null,
        key: 'selectSubcategory'
      });
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function selectSource(id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: id,
        key: 'selectSource'
      });
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function selectSubcategory(id) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: id,
        key: 'selectSubcategory'
      });
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: null,
        key: 'selectCategory'
      });
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}

export function onCheckCategories(ids) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: uniq(ids),
        key: 'checkCategories'
      });
     
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function onCheckSubcategories(ids) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: uniq(ids),
        key: 'checkSubcategories'
      });
     
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function onCheckTrashed(value) {
  return async (dispatch) => {
    try {
      dispatch({
        type: 'SET_QUESTIONS_KEY',
        data: value,
        key: 'isTrashed'
      });
     
    } catch (error) {
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}


export function createOrUpdateItemsPresentation(where) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: false})
      let result = await RestClient.post('questions', 'presentation/item', where);
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
    } catch (error) {
      dispatch({type: 'SET_QUESTIONS_KEY', key: 'isLoaded', data: true})
      throw new Error('ss');
      // processError(error, dispatch)
    }
  };
}